import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, keyframes } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { layers as akLayers } from '@atlaskit/theme/constants';
// @atlaskit/navigation has a specific z-index, so we need to layer the header
// components relative to that.
var navLayer = akLayers.navigation();
var layers = {
  header: navLayer - 10,
  blanket: navLayer - 5,
  slider: navLayer + 5
};
var mobileHeaderHeight = 54;
var xPositioning = function xPositioning(_ref) {
  var side = _ref.side,
    isOpen = _ref.isOpen;
  return side === 'right' ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
  css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\tright: 0;\n\t\t\t\ttransform: translateX(", ");\n\t\t\t"])), isOpen ? '0' : '100vw') : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
  css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\tleft: 0;\n\t\t\t\ttransform: translateX(", ");\n\t\t\t"])), isOpen ? '0' : '-100vw');
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MobileNavSlider = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "calc(100vh - ".concat(props.topOffset, "px)"),
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat(props.topOffset, "px"),
    transition: 'transform 0.2s ease-out',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: layers.slider
  };
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
xPositioning);

// make space so content below doesn't slip beneath the header
// since the content is `position: fixed`
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MobilePageHeader = styled.header({
  height: "".concat(mobileHeaderHeight, "px")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MobilePageHeaderContent = styled.div(function (props) {
  return {
    alignItems: 'center',
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
    boxSizing: 'border-box',
    display: 'flex',
    height: "".concat(mobileHeaderHeight, "px"),
    padding: "var(--ds-space-100, 8px)",
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat(props.topOffset, "px"),
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: layers.header
  };
});
var opacityIn = keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var opacityOut = keyframes({
  from: {
    opacity: 1
  },
  to: {
    opacity: 0
  }
});

// @atlaskit/blanket has a z-index *higher* than @atlaskit/navigation,
// so we can't display the AK blanket underneath the navigation.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FakeBlanket = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tbackground: ", ";\n\tbottom: 0;\n\tleft: 0;\n\tposition: fixed;\n\tright: 0;\n\ttop: 0;\n\tz-index: ", ";\n\tanimation: ", " 0.2s ease-out;\n"])), "var(--ds-blanket, #091E427D)", layers.blanket, function (p) {
  return p.isOpen ? opacityIn : opacityOut;
});

// use proper h1 and header styles but for mobile we don't want a top margin
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var PageHeading = styled.h1({
  flexGrow: 1,
  margin: 0,
  marginLeft: "var(--ds-space-100, 8px)",
  font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  alignSelf: 'center'
});